export default function recycle(instance, factory, properties) {
  if (!instance || !instance.setProperties) return factory.create(properties);
  instance.setProperties(properties);
  return instance;
}
